<template>
  <v-app class="app">
    <NavBar :praxisData="praxisData" />
    <HeroImage />
    <OpeningTimes :praxisData="praxisData" />
    <HausarztProgramm />
    <StandOrt :praxisData="praxisData" />
    <!-- <ServicesComponent /> -->
    <FooterComponent :praxisData="praxisData" />
  </v-app>
</template>

<script>
import NavBar from './components/NavBar.vue';
import HeroImage from './components/HeroImage.vue';
import OpeningTimes from './components/OpeningTimes.vue';
import StandOrt from './components/StandOrt.vue';
import HausarztProgramm from './components/HausarztProgramm.vue';
// import ServicesComponent from './components/ServicesComponent.vue';
import FooterComponent from './components/FooterComponent.vue';

export default {
  components: {
    NavBar,
    HeroImage,
    OpeningTimes,
    StandOrt,
    HausarztProgramm,
    // ServicesComponent,
    FooterComponent,
  },

  data() {
    return ({
      praxisData: [
        {
          name: 'Nordenham',
          phone: '04731-8711567',
          fax: '04731-9519237',
          address: 'Bahnhofstraße 51/a',
          postcode: '26954',
          opening: {
            mo: [{start: '7:30', end: '10:30'}, {start: '10:30', end: '12:00', info: 'Mit Termin'}, {start: '16:00', end: '18:00'}],
            di: [{start: '7:30', end: '10:30'}, {start: '10:30', end: '12:00', info: 'Mit Termin'}],
            mi: [{start: '7:30', end: '10:30'}, {start: '10:30', end: '12:00', info: 'Mit Termin'}, {start: '15:00', end: '16:00'}],
            do: [{start: '7:30', end: '10:30'}, {start: '10:30', end: '12:00', info: 'Mit Termin'}, {start: '16:00', end: '18:00'}],
            fr: [{start: '7:30', end: '10:30'}, {start: '10:30', end: '12:00', info: 'Mit Termin'}, {start: '15:00', end: '16:00'}],
            sa: [{start: '10:00', end: '11:00', info: 'Notfallsprechstunde'}],
          }
        }
      ]
    });
  }
};
</script>

<style>
:root {
  --primary: #103354;
}

h1, h2 {
  color: var(--primary);
}

.mobileOnly {
  display: none;
}

@media screen and (max-width: 700px) {
  .mobileOnly {
    display: block;
  }
}

@media screen and (max-width: 700px) {
  .desktopOnly {
    display: none;
  }
}
</style>